var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarClock(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4571_44522",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4571_44522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 5.99609H14.25V4.49609H3.75V5.99609ZM3.75 16.4961C3.3375 16.4961 2.98438 16.3492 2.69062 16.0555C2.39688 15.7617 2.25 15.4086 2.25 14.9961V4.49609C2.25 4.08359 2.39688 3.73047 2.69062 3.43672C2.98438 3.14297 3.3375 2.99609 3.75 2.99609H4.5V1.49609H6V2.99609H12V1.49609H13.5V2.99609H14.25C14.6625 2.99609 15.0156 3.14297 15.3094 3.43672C15.6031 3.73047 15.75 4.08359 15.75 4.49609V8.75234C15.5125 8.63984 15.2687 8.54609 15.0187 8.47109C14.7687 8.39609 14.5125 8.33984 14.25 8.30234V7.49609H3.75V14.9961H8.475C8.5625 15.2711 8.66563 15.5336 8.78437 15.7836C8.90312 16.0336 9.04375 16.2711 9.20625 16.4961H3.75ZM13.5 17.2461C12.4625 17.2461 11.5781 16.8805 10.8469 16.1492C10.1156 15.418 9.75 14.5336 9.75 13.4961C9.75 12.4586 10.1156 11.5742 10.8469 10.843C11.5781 10.1117 12.4625 9.74609 13.5 9.74609C14.5375 9.74609 15.4219 10.1117 16.1531 10.843C16.8844 11.5742 17.25 12.4586 17.25 13.4961C17.25 14.5336 16.8844 15.418 16.1531 16.1492C15.4219 16.8805 14.5375 17.2461 13.5 17.2461ZM14.7562 15.2773L15.2812 14.7523L13.875 13.3461V11.2461H13.125V13.6461L14.7562 15.2773Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarClock);
export default __webpack_public_path__ + "static/media/calendar_clock.bf439a511f7f292a6422b8644eaa349b.svg";
export { ForwardRef as ReactComponent };